import { Alert, Stack, Text } from "@mantine/core";
import { generatePath, Link } from "react-router";
import { COMPONENTS_PANEL_ID } from "../../../../../../components/StructureView/ComponentsPanel/ComponentsPanel";
import { AlertPresets } from "../../../../../../mantine/mantinePresets";
import { ROUTES } from "../../../../../../routes";
import { ObjectUrlName } from "../../../../../../utils/enums";
import type { Paragraph6GeneratorListElement } from "../../../../Paragraph6.types";

interface BlockingErrorAlertProps {
  projectId: string;
  selectedGenerator: Paragraph6GeneratorListElement;
  installierteLeistungError?: string;
  anlagenschluesselError?: string;
  weightingError?: string;
}

function BlockingErrorAlert({
  projectId,
  selectedGenerator,
  installierteLeistungError,
  anlagenschluesselError,
  weightingError
}: BlockingErrorAlertProps) {
  const generatorRoute = generatePath(ROUTES.site.generator, {
    projectId,
    siteId: String(selectedGenerator?.site || ""),
    componentId: String(selectedGenerator.generator)
  });
  const weightingRoute = generatePath(ROUTES.site.entry, {
    projectId,
    siteId: String(selectedGenerator?.site || "")
  });

  return (
    <Alert
      color={AlertPresets.error.color}
      icon={AlertPresets.error.icon}
      mb="sm"
    >
      <Stack gap="xs">
        {(installierteLeistungError || anlagenschluesselError) && (
          <Stack gap={0}>
            <Text>{installierteLeistungError || anlagenschluesselError}</Text>
            <Link target="_blank" to={`${generatorRoute}?tab=eeg-anlage`}>
              Zum Erzeuger
            </Link>
          </Stack>
        )}
        {weightingError && (
          <Stack gap={0}>
            <Text>{weightingError}</Text>
            <Link
              target="_blank"
              to={`${weightingRoute}/${ObjectUrlName.Weightings}#${COMPONENTS_PANEL_ID}`}
            >
              Zu den Erzeugungsanteilen
            </Link>
          </Stack>
        )}
      </Stack>
    </Alert>
  );
}

export { BlockingErrorAlert };
